import React from "react";
import { TableCell } from "@mui/material";

import { ProcurementReportScheduleGridResponse } from "@/main/models/response";

import ActionsReportSchedule from "./actionsReportSchedule/actionsReportSchedule";
import * as S from "./styles";
import { IEditDataSchedule } from "../../types";

interface IRowDataCheduleReportProps {
	scheduleReport: ProcurementReportScheduleGridResponse;
	refreshGrid: () => void;
	updateDataEdit: (data: IEditDataSchedule) => void;
}
function RowDataCheduleReport({ scheduleReport, updateDataEdit, refreshGrid }: IRowDataCheduleReportProps) {
	function handleClickRow(e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
	}

	return (
		<>
			<S.Container $isSizeLong onClick={handleClickRow}>
				<TableCell>
					<S.CustomColumn title={scheduleReport.insurerName}>{scheduleReport.insurerName}</S.CustomColumn>
				</TableCell>
				<TableCell>
					<S.CustomColumn title={scheduleReport.bodyShopName}>{scheduleReport.bodyShopName}</S.CustomColumn>
				</TableCell>
				<TableCell>
					<S.CustomColumn title={scheduleReport.vehicleFullName}>{scheduleReport.vehicleFullName}</S.CustomColumn>
				</TableCell>
				<TableCell>
					<S.CustomColumn title={scheduleReport.supplierName}>{scheduleReport.supplierName}</S.CustomColumn>
				</TableCell>
				<TableCell>
					<S.CustomColumn title={scheduleReport.formattedStartDate}>{scheduleReport.formattedStartDate}</S.CustomColumn>
				</TableCell>
				<TableCell>
					<S.CustomColumn title={scheduleReport.formattedFinalDate}>{scheduleReport.formattedFinalDate}</S.CustomColumn>
				</TableCell>
				<TableCell>
					<S.CustomColumn title={scheduleReport.usernames}>{scheduleReport.usernames}</S.CustomColumn>
				</TableCell>
				<TableCell>
					<S.CustomColumn title={scheduleReport.dateAndUsername}>{scheduleReport.dateAndUsername}</S.CustomColumn>
				</TableCell>
				<TableCell>
					<S.CustomColumn>
						<ActionsReportSchedule
							scheduleReport={scheduleReport}
							refreshGrid={refreshGrid}
							updateDataEdit={updateDataEdit}
						/>
					</S.CustomColumn>
				</TableCell>
			</S.Container>
		</>
	);
}

export default RowDataCheduleReport;
